<script>
/**
 * Contact component
 */
export default {
  name: "Contact",

  data: () => {
    return {
      name: "",
      subject: "",
      message: "",
    };
  },

  methods: {
    sendEmail() {
      alert(this.name);
    },
  },
};
</script>

<template>
  <!-- CONTACT FORM START-->
  <section class="section" id="contact">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <h1 class="section-title text-center">Get In Touch</h1>
          <div class="section-title-border margin-t-20"></div>
          <p
            class="section-subtitle text-muted text-center font-secondary padding-t-30"
          >
            Leave us a message, describing your needs. A member from our team
            will respond as soon as possible.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4">
          <div class="mt-4 pt-4">
            <p class="mt-4">
              <span class="h5">Address:</span>
              <br />
              <span class="text-muted d-block mt-2"
                >Makedonias 52, Iraklio, 141 21, Greece</span
              >
            </p>
            <p class="mt-4">
              <span class="h5">Contact Details:</span>
              <br />
              <span class="text-muted d-block mt-2">M: +30.698.110.3023</span>
              <span class="text-muted d-block mt-2">E: info@apptime.gr</span>
            </p>
            <p class="mt-4">
              <a
                href="/Apptime_Services.pdf"
                class="btn btn-sm btn-outline-secondary"
                download
                >Download Services Brochure</a
              >
            </p>
          </div>
        </div>
        <div class="col-lg-8">
          <div class="custom-form mt-4 pt-4">
            <div id="message"></div>
            <form
              method="get"
              action="javascript:void(0);"
              name="contact-form"
              id="contact-form"
              enctype="text/plain"
            >
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group mt-2">
                    <input
                      name="name"
                      id="name"
                      type="text"
                      class="form-control"
                      placeholder="Your name*"
                      v-model="name"
                      required="required"
                    />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group mt-2">
                    <input
                      name="email"
                      id="email"
                      type="email"
                      class="form-control"
                      placeholder="Your email*"
                      required="required"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group mt-2">
                    <input
                      type="text"
                      class="form-control"
                      id="subject"
                      placeholder="Your Subject.."
                      v-model="subject"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group mt-2">
                    <textarea
                      name="comments"
                      id="comments"
                      rows="4"
                      class="form-control"
                      placeholder="Your message..."
                      v-model="message"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 text-right">
                  <input
                    type="button"
                    id="submit"
                    name="send"
                    class="submitBnt btn btn-custom"
                    value="Send Message"
                    :onclick="
                      'location.href=\'mailto:info@apptime.gr?subject=' +
                      encodeURIComponent(subject) +
                      '&body=' +
                      encodeURIComponent(message) +
                      '\''
                    "
                  />
                  <div id="simple-msg"></div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- CONTACT FORM END-->
</template>